// -*- coding: utf-8 -*
// jQuery Alert Dialogs Plugin
//
// Version 1.1
//
// Cory S.N. LaViska
// A Beautiful Site (http://abeautifulsite.net/)
// 14 May 2009
//
// Visit http://abeautifulsite.net/notebook/87 for more information
//
// Usage:
//		jAlert( message, [title, callback] )
//		jConfirm( message, [title, callback] )
//		jPrompt( message, [value, title, callback] )
//
// History:
//
//		1.00 - Released (29 December 2008)
//
//		1.01 - Fixed bug where unbinding would destroy all resize events
//
// License:
//
// This plugin is dual-licensed under the GNU General Public License and the MIT License and
// is copyright 2008 A Beautiful Site, LLC.
//
//
/////////////////////////////////
// 画像付き画面の呼び出し方
// 例：
// jAlert_img('メッセージ','<%= image_tag "画像ファイル名" %>' ,  "");
//
// 第1引数：メッセージ。
// 第2引数：画像タグ。
// （最終的に<img >タグを渡してあげればいいんですが、画像パスの問題があるので、railsで展開した<img>タグを渡してます）。
// 第3引数：タイトル。（CSSでタイトル部削ってるので、いれても変になると思います）

// 全部のダイアログに言えることですが、
// _showで、<div>などのタグを差し込んで、画面を生成してます。
// 文言や画像ファイル名などは呼び出し元で指定できますが、
// レイアウトが根本から違う物は_showを改造するか、「jAlert_img」や「jConfirmClose」みたいに新しく作成してください。

/////////////////////////////////
// 閉じるボタン付き確認ダイアログの左右ボタンの文言を引数で指定可能に修正しました。
// また左右のボタンの色も指定可能です。
// message: ダイアログ内表示文言
// title: ダイアログタイトル
// callback: ボタン押下時の処理 返り値が"1"なら左ボタン、"2"なら右ボタンクリック
// leftText: 左ボタンテキスト
// rightText: 右ボタンテキスト
// btnDesignExchangeFlg: 左右ボタンのデザイン入れ替えフラグ
// 例：
// jConfirmClose('キャンセルしてもよろしければ<br>「はい」をタッチしてください', '', function(r) {
//    if(r == "1"){
//      console.log("左ボタンクリック");
//    } else if (r == "2") {
//      console.log("右ボタンクリック");
//    } else {
//      console.log("閉じるクリック");
//    }
// }, '左ボタン文言', '右ボタン文言', false);

var left_size = 0;
var scroll_top = 0;
var scroll_flg = true;
var useragent = window.navigator.userAgent.toLowerCase();

(function($) {

    $.alerts = {

        // These properties can be read/written by accessing $.alerts.propertyName from your scripts at any time

        verticalOffset: -20,                // vertical offset of the dialog from center screen, in pixels
        horizontalOffset: 0,                // horizontal offset of the dialog from center screen, in pixels/
        repositionOnResize: true,           // re-centers the dialog on window resize
        overlayOpacity: 0.3,                // transparency level of overlay
        overlayColor: '#000',               // base color of overlay
        draggable: false,                    // make the dialogs draggable (requires UI Draggables plugin)
        okButton:  '&nbsp;OK&nbsp;',         // text for the OK button
        cancelButton: '&nbsp;キャンセル&nbsp;', // text for the Cancel button
        dialogClass: null,                  // if specified, this class will be applied to all dialogs
        btnDesignExchangeFlg: false,
        productId: '',
        isShownContent: false,
        isImageLoaded: false,
        isSliderLoaded: false,

        // Public methods

        alert: function(message, title, callback) {
            if( title == null ) title = 'Alert';
            $.alerts._show(title, message, null, 'alert', function(result) {
                if( callback ) callback(result);
            }, null);
        },
        // add +++
        alert_img: function(message, title, callback, path,image_height) {
            if( title == null ) title = 'Alert_img';
            $.alerts._show(title, message, null, 'alert_img', function(result) {
                if( callback ) callback(result);
            }, path,image_height);
            $.alerts._reposition(true);
        },
        // add ---
        confirm: function(message, title, callback) {
            if( title == null ) title = 'Confirm';
            $.alerts._show(title, message, null, 'confirm', function(result) {
                if( callback ) callback(result);
            }, null);
        },
        // add +++
        confirm_close: function(message, title, callback) {
            if( title == null ) title = 'Confirm_close';
            $.alerts._show(title, message, null, 'confirm_close', function(result) {
                if( callback ) callback(result);
            }, null);
        },
        // add ---
        prompt: function(message, value, title, callback) {
            if( title == null ) title = 'Prompt';
            $.alerts._show(title, message, value, 'prompt', function(result) {
                if( callback ) callback(result);
            }, null);
        },
        // add +++
        login_alert: function(message, title, callback) {
            if( title == null ) title = 'Login_alert';
            $.alerts._show(title, message, null, 'login_alert', function(result) {
                if( callback ) callback(result);
            }, null);
        },
        address_select: function(message, title, callback) {
            if( title == null ) title = 'Address Select';
            $.alerts._show(title, message, null, 'address_select', function(result) {
                if( callback ) callback(result);
            }, null);
        },

        alert_after_append: function(message,append_item,title,callback){
          $.alerts.alert(message, title, callback);
          $("#popup_panel").after(append_item);
          $.alerts._reposition(true);
        },

        alert_iframe: function(message, title, callback, path,iframe_height) {
            if( title == null ) title = 'Alert_img';
            $.alerts._show(title, message, null, 'alert_iframe', function(result) {
                if( callback ) callback(result);
            }, path,iframe_height);
            $.alerts._reposition(true);
        },

        // add +++
        popup_img: function(message, title, callback, image_tag,image_height) {
            if( title == null ) title = 'Popup_img';
            $.alerts._show(title, message, null, 'popup_img', function(result) {
                if( callback ) callback(result);
            }, image_tag,image_height);
            $.alerts._reposition(true);
        },

        // add +++
        popup_movie: function(message, title, callback, movie_url,image_height) {
            if( title == null ) title = 'Popup_movie';
            $.alerts._show(title, message, null, 'popup_movie', function(result) {
                if( callback ) callback(result);
            }, movie_url,image_height);
            $.alerts._reposition(true);
        },

        // add +++
        popup_movie_sp: function(message, title, callback, movie_url,image_height) {
            if( title == null ) title = 'Popup_movie';
            $.alerts._show(title, message, null, 'popup_movie_sp', function(result) {
                if( callback ) callback(result);
            }, movie_url,image_height);
            $.alerts._reposition(true);
        },

        // add ---
        // Private methods

        _show: function(title, msg, value, type, callback, path,image_height) {

            $.alerts._hide();
            $.alerts._overlay('show');

            $("HEAD").append(
                '<meta name="viewport" content="width=device-width, initial-scale=1,maximum-scale=1,user-scalable=no" />');

            $("BODY").append(
                '<div id="popup_container" role="alertdialog">' +
                '<h1 id="popup_title"></h1>' +
                '<div id="popup_content">' +
                '<div id="popup_message"></div>' +
                '</div>' +
                '</div>');
            scroll_top = $(document).scrollTop();

            if( $.alerts.dialogClass ) $("#popup_container").addClass($.alerts.dialogClass);

            var pos = 'fixed';

            $("#popup_container").css({
                position: pos,
                zIndex: 99999,
                padding: 0,
                margin: 0
            });
            if (type == 'confirm_close') {
              $("#popup_container").addClass(type);
            }
            $("#popup_container").hide();   // 画面生成するため隠して、チラつき防止

            $("#popup_title").text(title);
            $("#popup_content").addClass(type);
            $("#popup_message").text(msg);
            $("#popup_message").html( $("#popup_message").text().replace(/\n/g, '<br />') );

            $.alerts._reposition();
            if (type == 'popup_img') {
                $("#popup_container").css({
                    'opacity': '0',
                });
            }
            $("#popup_container").show();   // 画面生成するためかくしてたので表示

            $.alerts._maintainPosition(true);

            switch( type ) {
                case 'alert':
                    $("#popup_message").after('<div id="popup_panel" tabindex="0" ><input type="button" class="button_style_ok" value="' + $.alerts.okButton + '" id="popup_ok" /></div>');
                    $("#popup_ok").click( function() {
                        $.alerts._hide();
                        callback(true);
                    });
                    // 2014/10/27 iOSでのfocus()動作不良対応
                    // $("#popup_ok").focus().keypress( function(e) {
                    $("#popup_ok").keypress( function(e) {
                        if( e.keyCode == 13 || e.keyCode == 27 ) $("#popup_ok").trigger('click');
                    });
                    break;
                // add +++
                case 'alert_img':
                    $("#popup_message").after($.alerts.divAlertImgBtn());
                    var image_tag = $("<img></img>");
                    image_tag.attr("src",path);
                    image_tag.css("height",image_height)
                    $("#popup_message").after(image_tag);
                    $("#popup_ok").click( function() {
                        $.alerts._hide();
                        callback(true);
                    });
                    // 2014/10/27 iOSでのfocus()動作不良対応
                    // $("#popup_ok").focus().keypress( function(e) {
                    $("#popup_ok").keypress( function(e) {
                        if( e.keyCode == 13 || e.keyCode == 27 ) $("#popup_ok").trigger('click');
                    });
                    $("#popup_container").show();   // 画面生成するためかくしてたので表示
                    //for(var i=0;i<1;i++){
                    $.alerts._reposition(); // 画像のサイズがあるため、再度読み込み
                    //}
                    break;
                // add +++
                case 'popup_img':
                    $("#popup_title").append($.alerts.divCloseBtn()).css("min-height","20px");
                    $("#popup_close_btn").trigger("create");

                    var isSlides = path.match(/^slide_images_/)

                    // 画像コンテンツ取得・挿入
                    imageTag = path;
                    if (isSlides) {
                        imageTag = $('.popup_base_images_' + $.alerts.productId).html().replace("base_slides", "slides").replace(/base_slide_popup_image/g,'slide_popup_image');
                    }
                    $("#popup_message").after(imageTag);
                    $("#popup_container").css({
                        'max-width': '95%',
                        'width': '350px',
                        'background': 'white',
                        'border': 'double thick orange',
                        'border-radius': '0'
                    });

                    // 閉じる処理設定
                    $("#popup_close").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(true);
                    });

                    // コンテンツ表示
                    // ダイアログサイズが可変のため、
                    // 画像およびスライダーの読み込み完了後にダイアログ位置修正を実行する
                    $.alerts._popupImgContentsShow(isSlides, path);

                    break;
                // add +++
                case 'popup_movie':
                    $("#popup_title").append($.alerts.divCloseBtn()).css("min-height","20px");
                    $("#popup_close_btn").trigger("create");
                    var iframe_tag = $("<iframe></iframe>");
                    iframe_tag.attr("src",path);
                    iframe_tag.attr("height",'315');
                    iframe_tag.attr("width",'560');
                    iframe_tag.attr("title", "YouTube video player");
                    iframe_tag.attr("frameborder", "0");
                    iframe_tag.attr("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
                    iframe_tag.attr("allowfullscreen", "");
                    $("#popup_message").after(iframe_tag);
                    $("#popup_container").css({
                        'max-width': '95%',
                        'width': '350px',
                        'background': 'white',
                        'border': 'double thick orange',
                        'border-radius': '0'
                    });
                    $("#popup_close").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(true);
                    });
                    $("#popup_container").show();   // 画面生成するためかくしてたので表示
                    $.alerts._reposition(); // 画像のサイズがあるため、再度読み込み
                    break;
                case 'popup_movie_sp':
                    $("#popup_title").append($.alerts.divCloseBtn()).css("min-height","20px");
                    $("#popup_close_btn").trigger("create");
                    var iframe_tag = $("<iframe></iframe>");
                    iframe_tag.attr("src",path);
                    iframe_tag.attr("height",'180');
                    iframe_tag.attr("width",'320');
                    iframe_tag.attr("title", "YouTube video player");
                    iframe_tag.attr("frameborder", "0");
                    iframe_tag.attr("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
                    iframe_tag.attr("allowfullscreen", "");
                    $("#popup_message").after(iframe_tag);
                    $("#popup_container").css({
                        'max-width': '95%',
                        'width': '350px',
                        'background': 'white',
                        'border': 'double thick orange',
                        'border-radius': '0'
                    });
                    $("#popup_close").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(true);
                    });
                    $("#popup_container").show();   // 画面生成するためかくしてたので表示
                    $.alerts._reposition(); // 画像のサイズがあるため、再度読み込み
                    break;
                // add ---
                case 'confirm':
                    $("#popup_message").after($.alerts.divConfirmBtn());
                    $("#popup_ok").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(true);
                    });
                    $("#popup_cancel").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(false);
                    });
                    //$("#popup_ok").focus();
                    $("#popup_ok, #popup_cancel").keypress( function(e) {
                        if( e.keyCode == 13 ) $("#popup_ok").trigger('click');
                        if( e.keyCode == 27 ) $("#popup_cancel").trigger('click');
                    });
                    break;
                // add +++
                case 'confirm_close':
                    $("#popup_title").append($.alerts.divCloseBtn()).css("min-height","20px");
                    $("#popup_message").after($.alerts.divConfirmBtn());
                    $("#popup_close_btn").trigger("create");
                    // ボタンが３つのため、BOOL型ではなくステータスで返す
                    $("#popup_ok").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(1);
                    });
                    $("#popup_cancel").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(2);
                    });
                    $("#popup_close").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(3);
                    });
                    //$("#popup_ok").focus();
                    $("#popup_ok, #popup_cancel").keypress( function(e) {
                        if( e.keyCode == 13 ) $("#popup_ok").trigger('click');
                        if( e.keyCode == 27 ) $("#popup_cancel").trigger('click');
                    });
                    break;
                // add ---
                case 'prompt':
                    $("#popup_message").append('<br /><input type="text" size="30" id="popup_prompt" />').after('<div id="popup_panel" tabindex="0"><input type="button" class="button_style_ok" value="' + $.alerts.okButton + '" id="popup_ok" />&nbsp;<input type="button" class="button_style_cancel" value="' + $.alerts.cancelButton + '" id="popup_cancel" /></div>');
                    $("#popup_prompt").width( $("#popup_message").width() );
                    $("#popup_ok").click( function() {
                        var val = $("#popup_prompt").val();
                        $.alerts._hide();
                        if( callback ) callback( val );
                    });
                    $("#popup_cancel").click( function() {
                        $.alerts._hide();
                        if( callback ) callback( null );
                    });
                    $("#popup_prompt, #popup_ok, #popup_cancel").keypress( function(e) {
                        if( e.keyCode == 13 ) $("#popup_ok").trigger('click');
                        if( e.keyCode == 27 ) $("#popup_cancel").trigger('click');
                    });
                    if( value ) $("#popup_prompt").val(value);
                    $("#popup_prompt").focus().select();
                    break;
                // add +++
                case 'login_alert':
                    $("#popup_title").append($.alerts.divCloseBtn()).css("min-height","20px");
                    $("#popup_message").after($.alerts.divLoginBtn());
                    $("#popup_close_btn").trigger("create");
                    // ボタンが３つのため、BOOL型ではなくステータスで返す
                    $("#popup_login").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(1);
                    });
                    $("#popup_entry").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(2);
                    });
                    $("#popup_close").click( function() {
                        $.alerts._hide();
                        if( callback ) callback(3);
                    });
                    //$("#popup_login").focus();
                    $("#popup_login").keypress( function(e) {
                        if( e.keyCode == 13 ) $("#popup_ok").trigger('click');
                    });
                    break;
            // add ---
              case 'address_select':
                  $("#popup_message").after('<div id="popup_panel" tabindex="0" ><input type="button" class="button_style_ok" value="\u9589\u3058\u308B" id="popup_ok" /></div>');
                  $("#popup_ok").click( function() {
                      $.alerts._hide();
                      callback(true);
                  });
                  // 2014/10/27 iOSでのfocus()動作不良対応
                  // $("#popup_ok").focus().keypress( function(e) {
                  $("#popup_ok").keypress( function(e) {
                      if( e.keyCode == 13 || e.keyCode == 27 ) $("#popup_ok").trigger('click');
                  });
                  break;
              case 'alert_iframe':
                var iframe_tag = $("<iframe></iframe>");
                iframe_tag.attr("src",path);
                iframe_tag.css("height",image_height);
                iframe_tag.css("width",'100%');
                iframe_tag.css("overflow-y", "auto");
                $("#popup_message").after(iframe_tag);
                $("#popup_container").show();   // 画面生成するためかくしてたので表示
                $("#popup_content iframe").on('load',function(){
                    $(this).css('height', '90vh');
                    $("#popup_content").css('overflow','auto');
                    $("#popup_content").css('-webkit-overflow-scrolling','touch');
                    $("#popup_content").css('height','90vh');
                    $("#popup_container").css('top','1vh');
                    $("#popup_container").css('max-width','100%');
                    $("#popup_container").css('min-width','90%');
                    $("#popup_container").css('overflow-y','scroll');
                    $("#popup_container").css('z-index','9999999999');
                    $("#popup_overlay").css('z-index','9999999999');
                    $("#popup_overlay").css('opacity','0.8');
                    $.alerts._reposition();
                });
                break;
            }
            // Make draggable
            if( $.alerts.draggable ) {
                try {
                    $("#popup_container").draggable({
                        handle: $("#popup_title")
                    });
                    $("#popup_title").css({
                        cursor: 'move'
                    });
                } catch(e) { /* requires jQuery UI draggables */ }
            }
            $("#popup_panel").focus();
        },

        _hide: function() {
            $("#popup_container").remove();
            $.alerts._overlay('hide');
            $.alerts._maintainPosition(false);
            left_size = 0;
            scroll_top = 0;
            scroll_flg = true;
        },

        _overlay: function(status) {
            switch( status ) {
                case 'show':
                    $.alerts._overlay('hide');
                    $("BODY").append('<div id="popup_overlay"></div>');
                    $("#popup_overlay").css({
                        position: 'absolute',
                        zIndex: 99998,
                        top: '0px',
                        left: '0px',
                        width: '100%',
                        height: $(document).height(),
                        background: $.alerts.overlayColor,
                        opacity: $.alerts.overlayOpacity
                    });
                    break;
                case 'hide':
                    $("#popup_overlay").remove();
                    break;
            }
        },

        _reposition: function(must_repos) {
            var top = (($(window).height() / 2) - ($("#popup_container").outerHeight() / 2)) + $.alerts.verticalOffset;
            var left = (($(window).width() / 2) - ($("#popup_container").outerWidth() / 2)) + $.alerts.horizontalOffset;
            if( top < 0 ) top = 0;
            if( left < 0 ) left = 0;

            // android2.3で最初に表示する際になぜか微妙に画面サイズの縦が変わり、何度か呼ばれるためちらつく
            // スマートフォン用の処理ため縦横が変わらない（横画面サイズが変わらないかぎり）画面を動かさない
            if(left_size != left || must_repos == true){
                $("#popup_container").css({
                    top: top + 'px',
                    left: left + 'px'
                });
                $("#popup_overlay").height( $(document).height() );
                left_size = left;
            }
            // 元画面がスクロールしていた場合、元にもどす
            if($(document).scrollTop() != scroll_top && scroll_flg){
                $("html,body").animate({
                    scrollTop: scroll_top
                }, 1);
                scroll_flg = false;
            }
        },

        _maintainPosition: function(status) {
            if( $.alerts.repositionOnResize ) {
                switch(status) {
                    case true:
                        $(window).bind('resize', $.alerts._reposition);
                        break;
                    case false:
                        $(window).unbind('resize', $.alerts._reposition);
                        break;
                }
                return false;
            }
        },

        _popupImgContentsShow: function(isSlides, path) {
            var imageIndex = 0;
            if (isSlides) {
                imageIndex = Number(path.replace("slide_images_", ""));
            }
            var allImageCount = $('.slide_popup_image').length;
            $.alerts.isShownContent = false
            $.alerts.isImageLoaded = false
            $.alerts.isSliderLoaded = false

            if (isSlides) {
                // 複数画像表示の場合

                // スライダースタイル設定
                $.alerts._popupImgSetSliderStyle();

                // 画像読み込み時
                $.alerts._popupImgLoad(allImageCount);

                // スライダー読み込み時
                $.alerts._popupSliderLoad(imageIndex);
            } else {
                // 単体画像表示の場合

                singleImg = $('.popup_img').find('img');
                singleImgSrc = singleImg.attr('src');
                singleImg.attr('src', '');

                // 画像読み込み完了時にダイアログ位置修正して表示
                singleImg.on('load', function() {
                    $.alerts.isShownContent = true;
                    $.alerts._popupImgShow();
                });
                singleImg.attr('src', singleImgSrc);
            }
            setTimeout(function(){
                if (!$.alerts.isShownContent) {
                    // 表示完了していなければダイアログ位置修正して表示
                    $.alerts.isShownContent = true;
                    $.alerts._popupImgShow();
                }
            },1500);
        },

        _popupImgLoad: function(allImageCount) {
            var imageCount = 0;
            $(".slide_popup_image").each(function(i, elem) {
                slideImgSrc = $(elem).attr('src');
                $(elem).attr('src', '');
                $(elem).on('load', function() {
                    ++imageCount;
                    if (imageCount == allImageCount) {
                        // 全ての画像が読み込まれた時
                        $.alerts.isImageLoaded = true
                        if ($.alerts.isSliderLoaded) {
                            // スライダー読み込みが完了していればダイアログ位置修正して表示
                            $.alerts.isShownContent = true;
                            $.alerts._popupImgShow();
                        }
                    }
                });
                $(elem).attr('src', slideImgSrc);
            });
        },

        _popupSliderLoad: function(imageIndex) {
            $('.popup_flexslider').flexslider({
                animation: "slide",
                prevText: "<span class='btn bg-success py-1 px-2 rounded-circle p-0 fw-bold flex-prev-text' style='width: 2.3rem; height: 2.3rem; transform: scale(-1, 1);'><span class='icon-right01 position-relative' style='top: 10%'></span></span>",
                nextText: "<span class='btn bg-success py-1 px-2 rounded-circle p-0 fw-bold flex-next-text' style='width: 2.3rem; height: 2.3rem;'><span class='icon-right01 position-relative' style='top: 10%'></span></span>",
                startAt: imageIndex,
                start: function(slider){
                    // サイズ・位置調整
                    popupHeight = $('#popup_container').height();
                    controlHeight = $('.popup_flexslider').children('.flex-control-nav').height();
                    $('#popup_container').height(popupHeight + controlHeight);

                    $.alerts.isSliderLoaded = true;
                    if ($.alerts.isImageLoaded) {
                        // 画像読み込みが完了していればダイアログ位置修正して表示
                        $.alerts.isShownContent = true;
                        $.alerts._popupImgShow();
                    }
                },
            });
        },

        _popupImgSetSliderStyle: function() {
            $("#popup_content").addClass('flexslider');
            $("#popup_content").addClass('popup_flexslider');
            $('#popup_content').css({
                'margin': '0 auto 20px',
                'height': 'auto',
                'width': 'auto',
            });
            $('.slide_popup_image').css({
                'max-width': 'none',
                'width': 'auto',
                'max-height': 'none',
                'height': 'auto',
            });
        },

        _popupImgShow: function(status) {
            // ダイアログ全体の高さ調整
            popupTitleHeight = $('#popup_title').outerHeight(true);
            popupContentHeight = $('#popup_content').outerHeight(true);
            $('#popup_container').height(popupTitleHeight + popupContentHeight);

            $.alerts._reposition(true);

            if ($('#popup_content').hasClass('popup_flexslider')) {
                diffWidth = ($(window).width() - $('#popup_container').width()) / 2 + 10
                diffHeight = $('#popup_container').height() / -2 + $('.flex-next').height()
                $('#popup_container').find('.flex-prev').css({
                    'left': diffWidth,
                    'top': diffHeight,
                });
                $('#popup_container').find('.flex-next').css({
                    'right': diffWidth,
                    'top': diffHeight,
                });
            }

            setTimeout(function(){
                $("#popup_container").css({
                    'opacity': '1',
                });
            },300)
        },

        divCloseBtn: function(){
            // ダイアログ
            var div_close_btn =
            '<div id="popup_close_btn" ><div class="button_space">' +
            '<button type="button" class="button_style_close"  id="popup_close" data-icon="delete" data-iconpos="notext">' +
            '<span class="icon-ibatu"></span>' +
            '</button></div></div>';
            return div_close_btn;
        },

        divConfirmBtn: function(){
            var button_style_ok = "button_style_ok ok_color";
            var button_style_cancel = "button_style_cancel cancel_color";
            if ($.alerts.btnDesignExchangeFlg) {
                button_style_ok = "button_style_ok cancel_color";
                button_style_cancel = "button_style_cancel ok_color";
            }
            var div_confirm_btn = '<div id="popup_panel" tabindex="0"><input type="button" class="' +
            button_style_ok +
            '" value="' +
            $.alerts.okButton +
            '" id="popup_ok" />&nbsp<input type="button" class="' +
            button_style_cancel +
            '" value="' +
            $.alerts.cancelButton +
            '" id="popup_cancel" /></div>';
            return div_confirm_btn;
        },
        divLoginBtn: function(){
            var div_login_btn = '<div id="popup_panel" tabindex="0">' +
            '<button type="button" class="button_style_ok" id="popup_entry">' +
            "\u4F1A\u54E1\u767B\u9332" +
            '</button>' +
            '&nbsp' +
            '<button type="button" class="button_style_ok" id="popup_login">' +
            "\u30ED\u30B0\u30A4\u30F3" +
            '</button></div>' +
            "<div class='px-3 pt-3' style='text-align:left;'>" +
            "<a target='webkanyu' style='width:100%;' class='webkanyu button_style_ok text-white text-decoration-none'" +
            " href='https://www2.tcoop.or.jp/lp/nakama-tokai1.html'>" +
            "\u8cc7\u6599\u8acb\u6c42\u30fb\u3054\u52a0\u5165\u306f\u3053\u3061\u3089\u304b\u3089</a></div>";
            return div_login_btn;
        },
        divAlertImgBtn: function(){
            var div_alert_img_btn = '<div id="popup_panel" tabindex="0" >' +
            '<input type="button" class="button_style" value="' +
            "閉じる" +
            '" id="popup_ok" /></div>';
            return div_alert_img_btn;
        }
    }

    // Shortuct functions
    jAlert = function(message, title, callback) {
        $.alerts.alert(message, title, callback);
    }
    // add +++
    jAlert_img = function(message, path, title, image_height,callback) {
        $.alerts.alert_img(message, title, callback, path,image_height);
    }
    // add +++
    jPopup_img = function(message, image_tag, title, image_height, prod_id,callback) {
        $.alerts.productId = prod_id;
        $.alerts.popup_img(message, title, callback, image_tag ,image_height);
    }
    // add +++
    jPopup_movie = function(message, movie_url, title, height,callback) {
        $.alerts.popup_movie(message, title, callback, movie_url ,height);
    }
    // add +++
    jPopup_movie_sp = function(message, movie_url, title, height,callback) {
        $.alerts.popup_movie_sp(message, title, callback, movie_url, height);
    }
    // add ---
    jConfirm = function(message, title, callback) {
        $.alerts.confirm(message, title, callback);
    };
    // add +++
    jConfirmClose = function(message, title, callback, leftText = '&nbsp;OK&nbsp;', rightText = '\u30ad\u30e3\u30f3\u30bb\u30eb', btnDesignExchangeFlg = false) {
        $.alerts.okButton = leftText
        $.alerts.cancelButton = rightText
        $.alerts.btnDesignExchangeFlg = btnDesignExchangeFlg
        $.alerts.confirm_close(message, title, callback);
    };
    // add ---
    jPrompt = function(message, value, title, callback) {
        $.alerts.prompt(message, value, title, callback);
    };
    // add +++
    jLoginAlert = function(message, title, callback) {
        $.alerts.login_alert(message, title, callback);
    };

    jAddressSelect = function(message, title, callback) {
        $.alerts.address_select(message, title, callback);
    };
// add ---
    // OKボタンのあとにHTML追加
    jAlertAfterAppend = function(message,append_item,title,callback){
      $.alerts.alert_after_append(message,append_item,title,callback)
    };

    jAlertIframe = function(path, iframe_height,callback) {
        $.alerts.alert_iframe('', '', callback, path,iframe_height);
    }

    jAlertHide = function(){
        $.alerts._hide();
    }

    settingDefaultButtonName = function(){
        $.alerts.okButton = '&nbsp;OK&nbsp;'
        $.alerts.cancelButton = '&nbsp;キャンセル&nbsp;'
    };

})(jQuery);

$(document).ready(function(){
    $(window).bind("scrollstart",function(evt){
        if ($("#popup_overlay").size() > 0 && $("#popup_overlay").height() < $(document).height()) {
            $("#popup_overlay").css('height',$(document).height())
        }
    })
});
